// NATIVE 
import { useEffect, useState } from 'react';


// INSTALLED 
import { useDispatch } from 'react-redux';
import Divider from '@mui/material/Divider';
import { Button, Card, Grid, IconButton, Tooltip } from '@mui/material';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';


// CUSTOM 
import { useField, useFormikContext } from 'formik';
import { uploadPdfStore } from '../../../store/uploaders';
import { UploadButtonField } from '../../formFields/uploadButtonField';
import { LinearProgressWithLabel } from '../../LinearProgressWithLabel';
import { DetailsComponents } from '../../DetailsComponents';
import { ModalViewPdfGlobal } from '../../modals/viwerPdf/ModalViewPdfGlobal';





/**
 * `ArchivosEditar` is a React functional component that provides a user interface for uploading and displaying
 * progress of various document uploads such as RUT, Chamber of Commerce, and Bank Certificate.
 * 
 * @param {any} props - The properties passed to the component.
 * 
 * @returns {JSX.Element} The rendered component.
 * 
 * @component
 * 
 * @example
 * <ArchivosEditar formField={formField} />
 * 
 * @remarks
 * This component uses several hooks:
 * - `useDispatch` from `react-redux` to dispatch actions.
 * - `useField` from `formik` to manage form fields.
 * - `useFormikContext` from `formik` to access formik context.
 * - `useState` from `react` to manage local state for upload progress and file names.
 * - `useEffect` from `react` to set initial upload progress based on formik values.
 * 
 * The component defines three asynchronous functions to handle file uploads:
 * - `uploadRut`
 * - `uploadCc`
 * - `uploadCb`
 * 
 * Each function updates the formik field value and dispatches an action to upload the file, updating the progress state accordingly.
 * 
 * The component renders a grid layout with three sections, each containing:
 * - A button with a tooltip explaining the document.
 * - An `UploadButtonField` component for file selection.
 * - A `Card` component displaying upload progress if a file is selected.
 */
export const ArchivosEditar = (props:any) => {


    // USE DISPATCH 
    const dispatch = useDispatch();


    // USE FIELD 
    const [field, meta] = useField(props);


    // USE FORMILK CONTEXT 
    const formikProps:any = useFormikContext();


    // USE STATE 
    const [percentage_upload_rut, setPercentageUploadRut] = useState(0);
    // const [file_rut, setFileRut] = useState(null);
    const [file_rut_name, setRutFileName] = useState('');

    const [percentage_upload_cc, setPercentageUploadCc]   = useState(0);
    const [file_cc, setFileCc]   = useState(null);
    const [file_cc_name, setCcFileName] = useState('');

    const [percentage_upload_cb, setPercentageUploadCb]   = useState(0);
    const [file_cb, setFileCb]   = useState(null);
    const [file_cb_name, setCbFileName] = useState('');

    

    
    // FORM FIELDS 
    const { formField: {
      e_rut,
      e_chamber_of_commerce,
      e_bank_certificate,
    }
  } = props;


  



  // USE EFFECT 
  useEffect(() => {
    
    if (formikProps.values.rut) {
        setPercentageUploadRut(100);
    }
    if (formikProps.values.chamber_of_commerce) {
      setPercentageUploadCc(100);
    }
    if (formikProps.values.bank_certificate) {
      setPercentageUploadCb(100);
    }
    
  }, [])
  
    
  // CONST FUNCTION 
  const uploadRut = async({ target }:any) => {
    
    formikProps.setFieldValue('e_rut', target.files[0]);
    const { ok, data } = await dispatch( uploadPdfStore( 'pdf-company', target.files[0], setPercentageUploadRut) );
    
    if (ok) {
      formikProps.setFieldValue('e_rut_name_saved_file', data.pdfName);
    }
    
  }




  const uploadCc = async({ target }:any) => {
   
    formikProps.setFieldValue('e_chamber_of_commerce', target.files[0]);
    const { ok, data } = await dispatch( uploadPdfStore( 'pdf-company', target.files[0], setPercentageUploadCc) );
    
    if (ok) {
      formikProps.setFieldValue('e_chamber_of_commerce_name_saved_name', data.pdfName);
    }
  }


  const uploadCb = async({ target }:any) => {
   
    formikProps.setFieldValue('e_bank_certificate', target.files[0]);
    const { ok, data } = await dispatch( uploadPdfStore( 'pdf-company' ,target.files[0], setPercentageUploadCb) );
    
    if (ok) {
       formikProps.setFieldValue('e_bank_certificate_name_saved_name', data.pdfName);
    }

  }



  // PARA VISOR DE PDF 
    const [urlRutPdf, setUrlRutPdf] = useState<any>(null);
    const [showPdfDetail, setShowPdfDetail] = useState(false);
    
    const openPdfDetail = (pdfFileName:string) => {
      setUrlRutPdf(pdfFileName);
      setShowPdfDetail(!showPdfDetail)
    }
  // FIN PARA VISOR PDF 

  
  return (
    <div>

        {/* DETALLE RUT  */}
          {
            // showRutDetail && <ModalViewPdf open={showRutDetail} typeUrl="customer-pdf"  onClose={  setShowRutDetail } pdfUrl={urlRutPdf} />
            showPdfDetail && <ModalViewPdfGlobal open={showPdfDetail} typeUrl="company"  onClose={  setShowPdfDetail } pdfUrl={urlRutPdf} />
          }
        {/* FIN DETALLE RUT  */}


        <Grid container spacing={2}>
            <Grid size={{ xs: 4 }}>
                <Button>  RUT  </Button>
                <Tooltip title="El RUT o Registro Único Tributario permite identificar, ubicar y clasificar a las personas y entidades, en su caso, que sean contribuyentes declarantes del impuesto de la renta y no contribuyentes declarantes de ingresos y patrimonio." >
                  <IconButton>
                      <HelpOutlineOutlinedIcon color='primary'/>
                    </IconButton>
                </Tooltip>
                <div onClick={ () => openPdfDetail(formikProps.values.e_rut) }>
                  <DetailsComponents />
                </div>
                <Divider/>
                
                <UploadButtonField accept={'application/pdf'} 
                                   name={e_rut.name} label={e_rut.label} 
                                   text={'Rut'} 
                                   onChange={uploadRut} />
                {
                  formikProps.values.e_rut 
                       ?
                        <Card variant="elevation" sx={{  marginTop: 1.5, padding: 1, height: '70%',  }}>
                         <LinearProgressWithLabel percentage={ percentage_upload_rut > 0 ? percentage_upload_rut : 100 } label={formikProps.values.e_rut.name || 'Rut'} hasIcon={true} /> 
                        </Card>
                       :
                       ''
                }
                
            </Grid>  
            <Grid size={{ xs: 4 }}>
                <Button>  CÁMARA Y COMERCIO   </Button>
                <Tooltip title="Es toda actividad económica organizada para la producción, transformación, circulación, administración o custodia de bienes, o para la prestación de servicios. La empresa puede ejecutar actividades de naturaleza industrial o productiva; comercial o de prestación de servicios." >
                  <IconButton>
                      <HelpOutlineOutlinedIcon color='primary'/>
                    </IconButton>
                </Tooltip>
                <div onClick={ () => openPdfDetail(formikProps.values.e_chamber_of_commerce) }>
                  <DetailsComponents />
                </div>
                <Divider/>
                <UploadButtonField accept={'application/pdf'} 
                                   name={e_chamber_of_commerce.name} 
                                   label={e_chamber_of_commerce.label} 
                                   text={'Cámara y Comercio'} 
                                   onChange={uploadCc}/>
                
                {
                  formikProps.values.e_chamber_of_commerce
                       ?
                       <Card variant="elevation" sx={{  marginTop: 1.5, padding: 1, height: '70%',  }}>
                        <LinearProgressWithLabel percentage={percentage_upload_cc > 0 ? percentage_upload_cc : 100} label={formikProps.values.e_chamber_of_commerce.name || 'Cámara y Comercio'} hasIcon={true} />
                       </Card>
                       :
                       ''
                }
            </Grid>
            <Grid size={{ xs: 4 }}>
                <Button>  CERTIFICADO BANCARIO   </Button>
                <Tooltip title="El Certificado Bancario es un título valor en moneda nacional o extranjera que es emitido al portador o nominativo por las empresas bancarias, en respaldo de la entrega de dinero en moneda extranjera, que garantiza una adecuada rentabilidad e inmediata liquidez." >
                  <IconButton>
                      <HelpOutlineOutlinedIcon color='primary'/>
                    </IconButton>
                </Tooltip>
                <div onClick={ () => openPdfDetail(formikProps.values.e_bank_certificate) }>
                  <DetailsComponents />
                </div>
                <Divider/>
                <UploadButtonField accept={'application/pdf'} 
                                   name={e_bank_certificate.name} 
                                   label={e_bank_certificate.label} 
                                   text={'Certificado bancario'} 
                                   onChange={uploadCb}/>
                
                {
                  formikProps.values.e_bank_certificate
                       ?
                       <Card variant="elevation" sx={{  marginTop: 1.5, padding: 1, height: '70%',  }}>
                          <LinearProgressWithLabel percentage={ percentage_upload_cb > 0 ? percentage_upload_cb : 100 } label={ formikProps.values.e_bank_certificate.name || 'Certificado bancario' } hasIcon={true}/>
                        </Card>
                       :
                       ''
                }
            </Grid>
        </Grid>
    </div> 
  )
}
